<template>
  <div class="discount-fields">
    <el-form-item label="Rabat (%)">
      <el-input-number
        v-model="form.percent"
        :min="1"
        :max="maxPercent"
        :step="5"
        size="small"
        data-testid="reels-discount-percent"
      />
      <span class="field-hint">od 1 do {{ maxPercent }}%</span>
    </el-form-item>
    <el-form-item label="Liczba użyć">
      <el-input-number
        v-model="form.maxUses"
        :min="1"
        :max="maxUses"
        :disabled="form.unlimited"
        size="small"
        data-testid="reels-discount-max-uses"
      />
      <el-checkbox
        v-model="form.unlimited"
        class="unlimited-checkbox"
        data-testid="reels-discount-unlimited"
      >
        bez limitu
      </el-checkbox>
    </el-form-item>
    <el-form-item label="Ważny do">
      <el-date-picker
        v-model="form.expiresAt"
        type="date"
        value-format="yyyy-MM-dd"
        format="dd.MM.yyyy"
        placeholder="bezterminowo"
        size="small"
        :picker-options="pickerOptions"
        data-testid="reels-discount-expires"
      />
      <span class="field-hint">do końca wybranego dnia; puste = bezterminowo</span>
    </el-form-item>
  </div>
</template>

<script>
import { MAX_DISCOUNT_PERCENT, MAX_DISCOUNT_USES, disabledPastDate } from '@/utils/reels';

/**
 * Pola rabatu na pakiety rolek (procent, liczba użyć / bez limitu, ważny do).
 * Pracuje bezpośrednio na obiekcie z `emptyDiscountForm()` z `@/utils/reels`.
 */
export default {
  name: 'DiscountFields',
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxPercent: MAX_DISCOUNT_PERCENT,
      maxUses: MAX_DISCOUNT_USES,
      pickerOptions: {
        disabledDate: disabledPastDate,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.field-hint {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}
.unlimited-checkbox {
  margin-left: 12px;
}
</style>
